import { useEffect, useState } from 'react';
import supabase from '../config/supabaseClient';

const useContactInfo = () => {
    const [contacts, setContacts] = useState([]);

    const fetchContacts = async () => {
        const { data, error } = await supabase
            .from('contact_info')
            .select('*')
            .order('created_at', { ascending: true });

        if (!error) setContacts(data);
    };

    const addContact = async (type, value) => {
        const { error } = await supabase
            .from('contact_info')
            .insert([{ type, value }]);
        if (!error) fetchContacts();
    };

    const updateContact = async (id, value) => {
        const { error } = await supabase
            .from('contact_info')
            .update({ value })
            .eq('id', id);
        if (!error) fetchContacts();
    };

    const deleteContact = async (id) => {
        const { error } = await supabase
            .from('contact_info')
            .delete()
            .eq('id', id);
        if (!error) fetchContacts();
    };

    useEffect(() => {
        fetchContacts();
    }, []);

    return { contacts, addContact, updateContact, deleteContact };
};

export { useContactInfo };